// src/pages/HomePage.tsx
import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Divider,
  Box,
  Button,
  Grid,
  Avatar,
} from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import useCustomerStore from '../stores/useCustomerStore';
import useAuthStore from '../stores/useAuthStore';
import CustomerSelect from '../components/CustomerSelect';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const { customerDetail } = useCustomerStore();
  const { adminInfo, user } = useAuthStore();
  const navigate = useNavigate();

  const handlePayment = () => {
    navigate('/installment');
  };

  const isAdmin = adminInfo?.isAdmin ?? false;
  const activeCustomer = isAdmin ? customerDetail : user;

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 5 } }}>
        {/* Başlık Bölümü */}
        <Box display="flex" alignItems="center" mb={3}>
          <Avatar sx={{ bgcolor: '#1976d2', width: 56, height: 56, mr: 2 }}>
            <HomeIcon />
          </Avatar>
          <Typography variant="h4" color="primary">
            {isAdmin ? 'Cari Yönetimi' : 'Ödeme Ekranı'}
          </Typography>
        </Box>
        {isAdmin && (
          <Box mb={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              İşlem yapacağınız cariyi seçiniz:
            </Typography>
            <CustomerSelect />
          </Box>
        )}
        <Divider sx={{ mb: 3 }} />
        {activeCustomer ? (
          <Grid container spacing={3}>
            {/* Cari Adı */}
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ bgcolor: '#e0f7fa', mr: 2 }}>
                  <PersonIcon color="primary" />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2">Cari Adı</Typography>
                  <Typography variant="body1">{activeCustomer.CariIsim}</Typography>
                </Box>
              </Paper>
            </Grid>
            {/* Cari Kodu */}
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ bgcolor: '#e8f5e9', mr: 2 }}>
                  <AccountBalanceWalletIcon color="success" />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2">Cari Kodu</Typography>
                  <Typography variant="body1">{activeCustomer.CariKod}</Typography>
                </Box>
              </Paper>
            </Grid>
            {/* Mevcut Bakiye */}
           
            {/* Adres */}
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ bgcolor: '#f3e5f5', mr: 2 }}>
                  <LocationOnIcon color="secondary" />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2">Adres</Typography>
                  <Typography variant="body1">{activeCustomer.Adres || '-'}</Typography>
                </Box>
              </Paper>
            </Grid>
            {/* Telefon */}
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ bgcolor: '#e1f5fe', mr: 2 }}>
                  <PhoneIcon color="primary" />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2">Telefon</Typography>
                  <Typography variant="body1">{activeCustomer.Telefon || '-'}</Typography>
                </Box>
              </Paper>
            </Grid>
            {/* E-posta */}
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ bgcolor: '#fff8e1', mr: 2 }}>
                  <EmailIcon color="action" />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2">E-posta</Typography>
                  <Typography variant="body1">{activeCustomer.Email || '-'}</Typography>
                </Box>
              </Paper>
            </Grid>
            {/* Ödeme Butonu */}
            <Grid item xs={12}>
              <Box textAlign="center" mt={3}>
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  startIcon={<PaymentIcon />}
                  onClick={handlePayment}
                >
                  Ödeme Yap
                </Button>
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Lütfen yukarıdan bir cari seçimi yapınız.
          </Typography>
        )}
      </Paper>
    </Container>
  );
}

export default HomePage;
